import apiClient from './apiClient';

// ============================================================
// Types — aligned with backend models
// (backend/modules/pw9411/models/pw9411.go)
// ============================================================

/** Employee basic information (F901) */
export interface EmployeeInfo {
  emp_code: string;     // F901_01 — 員工代號
  emp_name: string;     // F901_11 — 員工中文姓名
  emp_name_en: string;  // F901_55 — 英文名稱
  dept_code: string;    // F901_32 — 部門代碼
  ext: string;          // F901_54 — 分機
}

/** One day's attendance record (F910) */
export interface AttendanceRecord {
  attend_date: string;    // F910_02 (YYYY-MM-DD)
  clock_in: string;       // F910_21 — 刷卡上班時間
  clock_out: string;      // F910_22 — 刷卡下班時間
  ot_start: string;       // F910_23 — 加班刷卡開始時間
  ot_end: string;         // F910_24 — 加班刷卡結束時間
  late_minutes: number;   // F910_29 — 遲到分鐘數
  early_minutes: number;  // F910_30 — 早退分鐘數
  status_code: string;    // F910_11 — 出勤狀態碼
  leave_no: string;       // F910_17 — 請假單號
  trip_no: string;        // F910_19 — 出差單號
  shift_note: string;     // F910_14 — 出勤備註說明
  dept_code: string;      // F910_31 — 部門代號
}

/** Request body for attendance query (BR-Q01) */
export interface QueryRequest {
  emp_code: string;    // 員工代號（必填，來自 SYS_USER_ID 或手動輸入）
  date_start: string;  // 查詢起始日 (YYYY-MM-DD)
  date_end: string;    // 查詢截止日 (YYYY-MM-DD)
}

/** Full API response for personal attendance query */
export interface QueryResponse {
  employee: EmployeeInfo | null;
  records: AttendanceRecord[];
  total: number;
  query_time: string;  // ISO datetime
}

// ============================================================
// API Client
// ============================================================

export const pw9411Api = {
  /** GET /api/pw9411/employee/:empCode — 取得員工基本資料 */
  async getEmployee(empCode: string): Promise<EmployeeInfo | null> {
    try {
      const res = await apiClient.get(`/api/pw9411/employee/${encodeURIComponent(empCode.trim())}`);
      return res.data as EmployeeInfo;
    } catch (err: unknown) {
      const axiosErr = err as { response?: { status?: number } };
      if (axiosErr.response?.status === 404) return null;
      throw err;
    }
  },

  /** POST /api/pw9411/query — 查詢個人出勤記錄 */
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9411/query', req);
    return res.data as QueryResponse;
  },
};
